import { computed, Directive, inject, Signal } from '@angular/core';
import { LocalizationService } from '../../services/localization/localization.service';
import { ThemeService } from '../../services/theme-toggle/theme.service';
import { MenuService } from '../services/menu.service';
import { NAV_ITEMS } from '../components/header/constants/navs.constants';
import { NavigationService } from '../../services/navigation/navigation.service';
import { Router } from '@angular/router';
@Directive()
export abstract class LayoutBase {
  protected localization = inject(LocalizationService);
  protected theme = inject(ThemeService);
  protected menuService = inject(MenuService);
  protected navigationService = inject(NavigationService);
  protected navs = NAV_ITEMS;
  protected isMenuOpen = computed(() => this.menuService.isOpen());
  protected currentTheme = computed(() => this.theme.theme());
  protected router = inject(Router);

  protected toggleLang() {
    this.localization.changeLang();
  }
  protected toggleTheme() {
    this.theme.toggleTheme();
  }
  protected scrollToSection(id: string) {
    this.navigationService.scrollToSection(id);
  }

  handleNavClick(fragment: string) {
    if (this.router.url === '/' || this.router.url === '/#') {
      this.scrollToSection(fragment);
    } else {
      this.router.navigate(['/']).then(() => {
        setTimeout(() => {
          this.scrollToSection(fragment);
        }, 100);
      });
    }
  }
}
